export enum CommissionAcknowledgeStatusEnum {
    OPEN,
    ACKNOWLEDGED,
}
